// @core/api/endpoints/authn/list_login_records.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListLoginRecordsResponse,
} from '../../../types/authn';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/authn';

/**
 * List user login history
 * Returns a paginated list of login attempts for the current user including timestamps, IP addresses, and device information. Supports date range filtering for security auditing.
 */
export async function ListLoginRecords(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListLoginRecordsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/login-records`;
  const requestOptions = options;
  return client.get<ListLoginRecordsResponse>(requestPath, { ...requestOptions, params });
}
